import React, { useState } from 'react';
import {
  FDBodyText,
  FDBox, FDIcon,
  FDLozenge,
  FDStack,
  FDTextButton, FDTooltip,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import TaxStrategyItemNoteDialog
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/TabTemplatePicker/TaxStrategy/TaxStrategyItemNoteDialog';
import {
  TaxStrategyItemAdditionalInformationDialog,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/Sections/TaxSavingsSection/TaxStrategyItemAdditionalInformationDialog';
import { dataAttrs } from 'Helpers/Testing';

const TaxStrategyItemLayout = ({ itemStatusCollection, onSubmit }) => {
  const { resource } = useMetaLayoutContext();
  const [notesDialogOpen, setNotesDialogOpen] = useState(false);
  const [additionalInformationDialogOpen, setAdditionalInformationDialogOpen] = useState(false);

  const hasNotes = (resource.attr('internalNotes') !== undefined && resource.attr('internalNotes') !== '')
    || (resource.attr('memberNotes') !== undefined && resource.attr('memberNotes') !== '');
  const itemStatuses = itemStatusCollection.resources().list().filter((status) => {
    return status.attr('applicableItemValues').find((value) => {
      return value === resource.attr('value');
    }) !== undefined;
  });

  return (
    <>
      <FDStack
        direction={'row'}
        alignSelf={'center'}
        alignItems={'center'}
        spacing={2}
        width={'100%'}
      >
        <FDStack direction={'row'} width={'300px'} alignItems={'center'} spacing={1}>
          <FDBodyText value={resource.attr('name')} />
          <FDTooltip title={resource.attr('description')}>
            <FDIcon icon={'tooltip'} size={'sm'} color={'textSecondary'} />
          </FDTooltip>
        </FDStack>
        <FDBox width={'200px'}>
          <MetaControlField attr={'value'} />
        </FDBox>
        <FDBox width={'200px'}>
          <FDTextButton
            {...dataAttrs('tax-strategy-item-open-tax-note-dialog-btn')}
            onClick={(evt) => {
              evt.stopPropagation();
              evt.preventDefault();
              setNotesDialogOpen(true);
            }}
            icon={hasNotes ? 'preview' : 'add'}
            label={hasNotes ? 'View note' : 'Add note'}
          />
        </FDBox>
        <FDStack width={'200px'} spacing={1} direction={'row'} alignItems={'center'}>
          {
            itemStatuses.map((statusResource) => {
              return (<FDLozenge
                {...dataAttrs('tax-strategy-item-review-status-lozenge')}
                alignSelf={'center'}
                label={statusResource.attr('statusLabel')}
                color={statusResource.attr('status')}
              />);
            })
          }
        </FDStack>
      </FDStack>
      <TaxStrategyItemNoteDialog open={notesDialogOpen} setOpen={setNotesDialogOpen} onSubmit={onSubmit} />
      <TaxStrategyItemAdditionalInformationDialog itemResource={resource} setOpen={setAdditionalInformationDialogOpen} open={additionalInformationDialogOpen} />
    </>
  );
};

TaxStrategyItemLayout.defaultProps = {
};

TaxStrategyItemLayout.propTypes = {
  itemStatusCollection: PropTypes.instanceOf(fr.Collection).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default TaxStrategyItemLayout;
